export enum Boards {
  trd = "Trades",
  ma = "Machine",
  rr = "Railroad",
  n = "Warehouse",
  dk = "Dock",
  ws = "Wheat Specialty",
  wm = "Wheat Machine",
  cw = "Coastwise",
  ckdh = "Dock Checkers",
  fah = "First Aid",
  gan = "Gang",
  sqc = "Squamish",
  lin = "Lines",
  ts = "Topside",
  hld = "Hold",
  vis = "Visitors",
  sur = "Surplus",
}

export const BOARDS = Object.entries(Boards).map(
  ([key, value]) => ({ code: key, display: value })
);

export const BOARD_SWITH_SLIPS = Object.entries(Boards).filter(
  ([_, value]) => ([
    Boards.trd,
    Boards.ma,
    Boards.rr,
    Boards.n,
    Boards.dk,
    Boards.ws,
    Boards.wm,
    Boards.cw,
    Boards.ts,
    Boards.hld,
    Boards.sur,
  ].includes(value))
).map(([key]) => key);